import React, { useContext } from 'react'
import { Redirect } from 'react-router-dom'

import urls from '../../../utils/constants/urls'
import Spinner from '../../elem/Spinner'
import { UserContext } from '../../wrappers/UserContext'

const CallbackComponent = () => {
    const { user } = useContext(UserContext)

    if (user) {
        return <Redirect to={urls.home} />
    }

    return <Spinner />
}

export default CallbackComponent
